<app-modal [modalTitle]="modalTitle" [modalId]="modalId" (closeModal)="onCloseModal()">
  <div modalBody>
    <ul class="folder-tree">
      <app-folder-tree [folders]="folders" (selectedFolderHiearachy)="getSelectedFolderHiearachy($event)"></app-folder-tree>
    </ul>
  </div>
  <div class="folder-tree-footer" modalFooter>
    <button [hidden]="isSearchDetail" class="btn btn-primary btn-md btn-style" (click)="onAddFolder()" id="new-folder-btn">
      <img
        class="folder-tree-footer-image"
        [src]="isSelectedItemEncrypted ? '/assets/images/suite/storage/file-icons/icon_foldersecure.svg' : '/assets/images/suite/storage/file-icons/icon_folder.svg'"
        alt="folder-svg"
      />
      {{ isSelectedItemEncrypted ? ('NEW_ECRYPTED_FOLDER' | translate) : ('NEW_FOLDER' | translate) }}
    </button>
    <div *ngIf="isCopy"></div>
    <div class="modal-footer__right-actions">
      <button #btnCancelRef class="btn btn-outline-primary btn-md btn-style mr-8" id="cancel-btn" data-bs-dismiss="modal" (click)="onCloseModal()">
        {{ 'CANCEL' | translate }}
      </button>
      <button *ngIf="isSearchDetail; else notSearch" class="btn btn-primary btn-md btn-style" (click)="selectFolder()" [disabled]="!firstClicked" id="select-btn">
        {{ 'SELECT' | translate }}
      </button>
      <ng-template #notSearch>
        <button
          *ngIf="!isShares && !isCopy && !isTrash"
          class="btn btn-primary btn-md btn-style"
          (click)="isSelectedItemEncrypted ? moveEncryptedFolderoperation() : moveFolder()"
          [disabled]="!firstClicked || commonService.selectedId === 0"
          id="move-btn"
        >
          {{ 'MOVE' | translate }}
        </button>
        <button
          *ngIf="isShares"
          class="btn btn-primary btn-md btn-style"
          (click)="isSelectedItemEncrypted ? moveToEncryptedStorageFolderOperation() : moveToStorage()"
          [disabled]="!firstClicked || commonService.selectedId === 0"
          id="send-btn"
        >
          {{ 'TRANSFER' | translate }}
        </button>
        <button
          *ngIf="!isShares && !isTrash && isCopy"
          class="btn btn-primary btn-md btn-style"
          (click)="isSelectedItemEncrypted ? copyEncryptedFolderOperation() : copyToDirectory()"
          [disabled]="!firstClicked || commonService.selectedId === 0"
          id="copy-btn"
        >
          {{ 'COPY' | translate }}
        </button>
        <button *ngIf="isTrash" class="btn btn-primary btn-md btn-style" (click)="reverseOperation()" [disabled]="!firstClicked" id="copy-btn">
          {{ 'RESTORE' | translate }}
        </button>
      </ng-template>
    </div>
  </div>
</app-modal>
